<template>
  <div v-if="slides" :class="small ? 'smalltop' : ''">
    <div class="text-center">
      <div class="nav nav-slides" :class="small ? 'smallNav' : ''">
        <button @click="prev" class="nav-btn arrow arrow-left">&lt;</button>
        <span :class="!small ? 'number-buttons' : ''">
          <template v-for="n in slides">
          <button
            @click="setActive(n - 1)"
            class="nav-btn slide-btn"
            :class="active === n - 1? 'active-btn' : ''"
          >0{{ n }}
          </button>
        </template>
        </span>
        <button
          @click="next"
          class="nav-btn arrow arrow-right">&gt;
        </button>
      </div>
    </div>
    <div class="container slides">
      <div>
        <div>
          <slot name="item"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  let timeout = 0
  import smoothScroll from 'smooth-scroll'
  import Hammer from 'hammerjs'
  export default {
    props: {
      small: {
        default () {
          return false
        }
      },
      status: {
        default () {
          return false
        }
      },
      init: {
        default () {
          return 0
        }
      }
    },
    data () {
      return {
        active: this.init,
        slides: 0,
        clickedNav: false,
        display: true
      }
    },
    mounted () {
      window.addEventListener('scroll', this.findActive)
      this.slides = this.$slots.item.length
    },
    methods: {
      next () {
        if (this.active < this.slides - 1) {
          this.active += 1
          this.setActive(this.active)
        }
      },
      prev () {
        if (this.active > 0) {
          this.active -= 1
          this.setActive(this.active)
        }
      },
      setActive (active) {
        if (this.small) {
          smoothScroll.animateScroll(this.$children[active].$el)
        } else {
          for (let i = 0; i < this.slides; i++) {
            this.$children[i].active = (active === i)
          }
          this.clickedNav = active
          this.active = active
        }
        this.$emit('sc', {activeSlide: active})
      },
      findActive () {
        if (this.small) {
          for (let i = 0; i < this.slides; i++) {
            if (typeof this.$children[i].$data.inViewport !== 'undefined' && this.$children[i].$data.inViewport.now) {
              this.active = i
            }
          }
        }
      }
    },
    watch: {
      init (init) {
        if (init === -1) {
          this.active = 0
          this.clickedNav = false
        }
      },
      active (active) {
        this.$emit('sc', {activeSlide: active})
      },
      small (small) {
        // console.log(this.status)
        let active = this.clickedNav ? this.clickedNav : this.active
        // console.log(this.clickedNav)
        if (small && this.status) {
          smoothScroll.init({offset: 85})

          for (let i = 0; i < this.slides; i++) {
            this.$children[i].active = true
          }
          setTimeout(() => {
            // console.log(active)
            smoothScroll.animateScroll(this.$children[active].$el, '', {speed: 500, easing: 'Linear'})
          }, 5)
        } else {
          this.clickedNav = false
        }
      }
    }
  }
</script>

<style>
  .nav-btn {
    background-color: transparent;
    border: transparent;
    font-family: MoonBold;
    font-size: 40px;
    color: #d07075;
    outline: none;
  }

  .slide-btn {
    margin-left: 14px;
    margin-right: 14px;
  }

  .nav-btn.arrow-left {
  }

  .nav-btn.arrow-right {
  }

  .active-btn {
    text-decoration: underline;
    color: #8e2800 !important;
  }

  .slides {
    max-width: 705px;
  }

  .smallNav {
    position: fixed;
    left: 0;
    right: 0;
    top: 32px;
    z-index: 999;
    font-size: 15pt !important;
  }

  .smallNav .nav-btn {
    font-size: 19px;
    margin-left: 6px;
    margin-right: 7px;
  }

  .smallNav > .nav-btn.arrow-left {
    margin-left: 0;
    float: none;
    font-size: 40px;
    padding: 0px;
    position: relative;
    top: 8px;
    right: 30px;
  }

  .smallNav > .nav-btn.arrow-right {
    margin-left: 0;
    float: none;
    font-size: 40px;
    padding: 0px;
    position: relative;
    top: 8px;
    left: 30px;
  }

  .smalltop {
    padding-top: 100px;
  }

  .slideshow h1, .slideshow h2, .slideshow h3, .slideshow p {
    padding-left: 15px;
    padding-right: 15px;
  }

  .slideshow h1 {
    font-family: MoonBold !important;
    color: #8e2800 !important;
    font-size: 27px;
    margin-top: -5px;
    margin-left: 12px;
    margin-bottom: 0;
  }

  .slideshow h2 {
    font-family: Moon !important;
    color: #8e2800 !important;
    font-size: 18px;
    margin-left: 12px;
    margin-top: -17px;
    margin-bottom: 0px;

  }

  .descriptionTitle h6 {
    margin-top: -5px;
  }

  .slideshow p {
    font-family: MoonBold;
    color: #8e2800 !important;
    padding-left: 75px;
    padding-right: 65px;
    padding-bottom: 40px;
    letter-spacing: 0.7px;
    font-size: 12px;
    line-height: 14px;
    padding-top: 11px;
    margin-bottom: 6px;
  }

  .slideshow .image {
    float: none;
  }

  .image img {
    width: 413px;
  }

  @media (max-width: 767px) {
    .slideshow h1 {
      font-family: MoonBold !important;
      color: #8e2800 !important;
      font-size: 18px;
      margin-top: -5px;
      margin-left: 30px;
      margin-bottom: 0;
    }

    .slideshow h2 {
      font-family: Moon !important;
      color: #8e2800 !important;
      font-size: 18px;
      margin-left: 30px;
      margin-top: -10px;
      margin-bottom: 0px;

    }

    .slideshow p {
      padding-left: 46px;
      padding-right: 46px;
      padding-bottom: 40px;
      font-size: 8px;
    }

    .image img {
      width: 100%;
    }

    .container {
      padding-left: 0;
      padding-right: 0;
    }
  }

  @media (min-width: 413px) and (max-width: 768px) {
    .number-buttons {
      top: -8px;
      position: relative;
    }

    .slide-btn {
      font-size: 18px;
      margin-left: 0;
      margin-right: 0;
    }

    .smallNav .nav-btn {
      margin-left: 0;
      margin-right: 0;
    }

    .smallNav {
      position: fixed;
      left: 0;
      right: 0;
      top: 40px;
      z-index: 999;
    }

    .smallNav > .nav-btn.arrow-left {
      float: none;
      font-size: 40px;
      padding: 0px;
      top: 8px;
      right: 30px;
    }

    .smallNav > .nav-btn.arrow-right {
      float: none;
      font-size: 40px;
      padding: 0px;
      top: 8px;
      left: 30px;
    }
  }

  @media (max-width: 413px) {
    .slide-btn, .arrow {
      margin-left: 0;
      margin-right: 0;
      width: 30px;
      padding: 0;
    }

    .slide-btn {
      font-size: 19px;
    }

    .arrow {
      font-size: 40px;
      top: 8px;
      position: relative;
    }

    .nav-btn.arrow-left {
      margin-right: 0px;
    }

    .nav-btn.arrow-right {
      margin-left: 0px;
    }

    .nav-slides {
      margin-top: -10px;
    }

    .nav-slides.smallNav {
      margin-top: 0;
    }

    .smallNav > .nav-btn.arrow-left {
      right: 0
    }

    .smallNav > .nav-btn.arrow-right {
      left: 0
    }

    .smallNav .nav-btn {
      font-size: 19px;
      margin-left: 0px;
      margin-right: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// SlideShow.vue?c91a2dfe